import { render, staticRenderFns } from "./InviteLegalDetails.vue?vue&type=template&id=2750b21c&scoped=true&"
import script from "./InviteLegalDetails.vue?vue&type=script&lang=js&"
export * from "./InviteLegalDetails.vue?vue&type=script&lang=js&"
import style0 from "./InviteLegalDetails.vue?vue&type=style&index=0&id=2750b21c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2750b21c",
  null
  
)

export default component.exports